import { render, staticRenderFns } from "./Tariffs.vue?vue&type=template&id=2f67b8ba&"
import script from "./Tariffs.vue?vue&type=script&lang=ts&"
export * from "./Tariffs.vue?vue&type=script&lang=ts&"
import style0 from "./Tariffs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
